import { RightRail as Root } from './RightRail'
import { Header } from './Header/Header'
import { ScrollContent } from './ScrollContent/ScrollContent'
import { Actions } from './Actions/Actions'

export const RightRail = {
  Root,
  Header,
  Actions,
  ScrollContent,
}
